import * as React from 'react';
import { autobind } from 'office-ui-fabric-react/lib/Utilities';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { SharingRole, ClientId } from '../../interfaces/SharingInterfaces';
import { getRoleIconNameAndTitle } from '../../utilities/ShareHelper';
import strings from '../Share.resx';
import './RoleSelector.scss';
import Features from '@ms/odsp-utilities/lib/features/Features';
import { ResponsiveMode } from 'office-ui-fabric-react/lib/utilities/decorators/withResponsiveMode';

// Features
const ReviewPermissionUI = { ODB: 772 };

export interface IIconData {
    name: string;
    title: string;
}

export interface IRoleSelectorProps {
    onRoleChange: (value: SharingRole) => void;
    disabled?: boolean;
    role: SharingRole;
    clientId: ClientId;
    appmap?: string;
}

export class RoleSelector extends React.Component<IRoleSelectorProps, {}> {

    constructor(props: IRoleSelectorProps, context: any) {
        super(props);
    }

    public render(): React.ReactElement<{}> {

        const icon: IIconData = getRoleIconNameAndTitle(this.props.role);
        const showReview = Features.isFeatureEnabled(ReviewPermissionUI);
        const doesClientSupportReview = (this.props.clientId === ClientId.word) || (this.props.appmap && this.props.appmap === 'ms-word');
        const roleOptions: IDropdownOption[] = showReview && doesClientSupportReview ?
            [
                {
                    key: SharingRole.view,
                    text: strings.canViewRole,
                    data: strings.canViewRoleSubText
                },
                {
                    key: SharingRole.edit,
                    text: strings.canEditRole,
                    data: strings.canEditRoleSubText
                },
                {
                    key: SharingRole.review,
                    text: strings.canReviewRole,
                    data: strings.canReviewRoleSubText
                }
            ]
            :
            [
                {
                    key: SharingRole.view,
                    text: strings.canViewRole,
                    data: strings.canViewRoleSubText
                },
                {
                    key: SharingRole.edit,
                    text: strings.canEditRole,
                    data: strings.canEditRoleSubText
                }
            ];
        return (
            <div className='od-RoleSelector-wrapper'>
                <Icon
                    className='od-RoleSelector-settingIcon'
                    iconName={ icon.name }
                    title={ icon.title }
                />
                <Dropdown
                    className='od-RoleSelector-rolesDropdown'
                    disabled={ !!this.props.disabled }
                    label=''
                    onRenderTitle={ this._onRenderTitle }
                    onRenderOption={ this._onRenderOption }
                    onChanged={ this._onAllowRoleChange }
                    defaultSelectedKey={ this.props.role }
                    calloutProps={ {
                        className: 'od-RoleSelector-rolesDropdownOptionsCallout'
                    } }
                    responsiveMode={ ResponsiveMode.large }
                    options={ roleOptions }
                />
                { this.props.children }
            </div>
        );
    }

    @autobind
    private _onRenderTitle(options: IDropdownOption[]): JSX.Element {
        return (
            <span>{ options[0].text }</span>
        );
    }

    @autobind
    private _onRenderOption(option: IDropdownOption): JSX.Element {
        const icon: IIconData = getRoleIconNameAndTitle(option.key as SharingRole);

        return (
            <div className='od-RoleSelector-roleDropdownOption'>
                <div className='od-RoleSelector-roleDropdownOptionMainContent'>
                    <Icon
                        className='od-RoleSelector-settingIcon'
                        iconName={ icon.name }
                        title={ icon.title }
                    />
                    <span className='od-RoleSelector-roleDropdownOptionText'> { option.text } </span>
                </div>
                <span className='od-RoleSelector-roleDropdownOptionSubtext'>{ option.data }</span>
            </div>
        );
    }

    @autobind
    private _onAllowRoleChange(option: IDropdownOption): void {
        this.props.onRoleChange(option.key as SharingRole);
    }
}